import React, { useState, useEffect } from "react";
import "./Product_slider.css";
import MyReactImageMagnify from "./myReactImageMagnify/MyReactImageMagnify";
import { Modal } from "react-bootstrap";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";

const Product_slider = ({ product }) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [isMobile, setIsMobile] = useState(false);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    setActiveIndex(0);
  }, [product]);

  // Detect mobile
  useEffect(() => {
    const checkScreen = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkScreen();
    window.addEventListener("resize", checkScreen);

    return () => window.removeEventListener("resize", checkScreen);
  }, []);

  const images = product?.Product_Images || [];

  return (
    <section className="Product_slider_sec">
      <div className="slider_wrapper">
        {/* 🔹 MAIN IMAGE */}
        <div className="main_image_container">
          {images[activeIndex] && (
            <>
              {isMobile ? (
                <img
                  src={
                    process.env.REACT_APP_IMAGE_URL + images[activeIndex]?.image
                  }
                  alt="product"
                  className="mobile_main_img"
                  onClick={() => setShowModal(true)}
                />
              ) : (
                <MyReactImageMagnify
                  image={
                    process.env.REACT_APP_IMAGE_URL + images[activeIndex]?.image
                  }
                />
              )}
            </>
          )}
        </div>

        {/* 🔹 THUMBNAILS */}
        <Swiper
          modules={[Navigation]}
          navigation={true}
          spaceBetween={10}
          slidesPerView={4}
          className="thumb_swiper"
          breakpoints={{
            320: { slidesPerView: 3 },
            576: { slidesPerView: 4 },
            768: { slidesPerView: 5 },
            1024: { slidesPerView: 6 },
          }}
        >
          {images.map((img, index) => (
            <SwiperSlide key={index}>
              <div
                className={`thumb_item ${
                  activeIndex === index ? "active" : ""
                }`}
                onClick={() => setActiveIndex(index)}
              >
                <img
                  src={process.env.REACT_APP_IMAGE_URL + img?.image}
                  alt=""
                  className="thumb_img"
                />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>

      {/* 🔥 MODAL FOR MOBILE */}
      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        centered
        size="lg"
        className="product_modal"
      >
        <Modal.Header closeButton />

        <Modal.Body>
          {/* MAIN IMAGE */}
          <div className="modal_main_img_wrapper">
            <img
              src={process.env.REACT_APP_IMAGE_URL + images[activeIndex]?.image}
              alt=""
              className="modal_img"
            />
          </div>

          {/* THUMBNAILS */}
         <Swiper
          modules={[Navigation]}
          navigation={true}
          spaceBetween={10}
          slidesPerView={4}
          className="thumb_swiper"
          breakpoints={{
            320: { slidesPerView: 3 },
            576: { slidesPerView: 4 },
            768: { slidesPerView: 5 },
            1024: { slidesPerView: 6 },
          }}
        >
          {images.map((img, index) => (
            <SwiperSlide key={index}>
              <div
                className={`thumb_item ${
                  activeIndex === index ? "active" : ""
                }`}
                onClick={() => setActiveIndex(index)}
              >
                <img
                  src={process.env.REACT_APP_IMAGE_URL + img?.image}
                  alt=""
                  className="thumb_img"
                />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
        </Modal.Body>
      </Modal>
    </section>
  );
};

export default Product_slider;
